import { request } from "@/utils/request";

//新增数据
export function consultationLogAdd(data,config) {
  return request({
    method: "post",
    url: "/api/patrol/sys/consultationLog/add",
    data,
    config,
  });
}


